<template>
  <section>
    <navigation  :activeTab='"league"'></navigation>

    <div class="mdl-grid center-items">
      <div class="mdl-cell mdl-cell--12-col center-items">
        <div v-if="leagueKey=='notfound'">
            <h5 style="text-align: center"><router-link to="/">Join or Create a league!</router-link></h5>
        </div>
        <div v-else-if="leagueKey!='unknown'">
          <h5 id="leagueNameText" class="center-align">{{leagueName}} Standings</h5>
          <div class="table-responsive">
            <table id="leagueTable" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
              <thead>
                <tr>
                  <th class="mdl-data-table__cell--non-numeric">Team Name</th>
                  <th >Points</th>
                  <th >ABs</th>
                  <th >OPS</th>
                  <th >Runs</th>
                  <th >HRs</th>
                  <th >RBI</th>
                  <th >SBs</th>
                  <th >IP</th>
                  <th >Wins</th>
                  <th >Saves</th>
                  <th >Ks</th>
                  <th >ERA</th>
                  <th >WHIP</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t,key) of sortedTeams" :key="key">
                  <td style="text-align: left"><router-link :to="`/team/${leagueKey}/${key}`">{{ t.teamName }}</router-link></td>
                  <td>{{ t.leaguePoints }}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterAbs","newAbs")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterOps","newOps")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterRuns","newRuns")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterHRs","newHrs")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterRBI","newRBI")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumBatterSbs","newSbs")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherIp","newIp")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherWins","newWins")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherSaves","newSaves")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherKs","newKs")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherEra","newEra")}}</td>
                  <td>{{ getTotalsWithWeek(t,"accumPitcherWhip","newWhip")}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--12-col">
        <h5 class="left-align" style="padding: 0px 12px;">Recent Transactions</h5>
        <div v-for="t of transactions" class="mdl-cell mdl-cell--12-col">
          <PastTransaction :transaction="t" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from '../db'
import firebase from "firebase";
import navigation from "@/components/NavBar.vue";
import PastTransaction from "@/components/PastTransaction.vue";

export default {
  data() {
    return {
      leagues: [],
      latestWeekKey: "latestweek",
      leagueKey: "unknown",
      leagueName: "Unknown League Name",
      user: null,
      transactions: null,
    }
  },
  components: {
    navigation,
    PastTransaction,
  },
  firebase: {
    leagues: db.ref('leagues/'),
  },
  created() {
    firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
            this.user = user;
            let tmp = "notfound"
            await db.ref('users/'+user.uid+'/leagues/').once('value',function(snapshot){
                snapshot.forEach(function(childSnapshot){
                    tmp = childSnapshot.val().leagueUID
                })
            })
            this.leagueKey = tmp

            let tmpWeekVal = 0
            let tmpWeekKey = this.latestWeekKey
            await db.ref('/weeks2021').once('value',function(snapshot){
              snapshot.forEach(function(childSnapshot){
                if (childSnapshot.val() > tmpWeekVal){
                  tmpWeekVal = childSnapshot.val()
                  tmpWeekKey = childSnapshot.key
                }
              })
            })

            this.latestWeekKey = tmpWeekKey
        }
    });
  },
  computed: {
    sortedTeams() {
      let ordered = {};
      for (let l of this.leagues){
        if (l['.key']==this.leagueKey){
          this.leagueName = l["leagueName"]
          let teams = l["teams"]
          Object.keys(teams).sort( (a,b) => {
            return teams[b]["leaguePoints"] - teams[a]["leaguePoints"]
          } ).forEach(function(key) {
            ordered[key] = teams[key];
          });
        }
      }
      return ordered
    }
  },
  methods: {
    getTotalsWithWeek(t,accumCat,weeklyCat) {
      if(t["season"] && t["season"][this.latestWeekKey]) {
        if (weeklyCat == "newEra" || weeklyCat=="newWhip" || weeklyCat=="newOps")
          return t["season"][this.latestWeekKey]["weeklyTotals"][weeklyCat]
        else if (weeklyCat == "newIp")
          return (t["season"][this.latestWeekKey]["weeklyTotals"][weeklyCat] + t["totals"][accumCat]).toFixed(3)

        return t["season"][this.latestWeekKey]["weeklyTotals"][weeklyCat] + t["totals"][accumCat]
      }
      return t["totals"][accumCat]
    },
  },
  watch: {
    leagueKey: {
      // call it upon creation too
      immediate: true,
      handler(leagueKey) {
        this.$rtdbBind('transactions', db.ref('transactions').child(leagueKey).limitToLast(10))
      },
    },
  },
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/League.vue